export const homePageName = 'home';
export const setPasswordPageName = 'set-password';
export const forgotPasswordPageName = 'forgot-password';
export const changePasswordPageName = 'change-password';
export const editProfilePageName = 'edit-profile';
export const loginPageName = 'login';
export const userManagementPageName = 'user-management';
export const userEditPageName = 'user-edit';
export const clientAdministrationPageName = 'client-administration';
export const categoryPageName = 'category';
export const subscriptionPageName ='subscription';
export const privacypolicyPageName='privacy-policy';
export const publicPrivacyPolicyPageName='circlecart-privacy-policy';
export const orderPageName = 'order';
export const deleteAccountPageName = 'delete-account';
export const deliverydetailsPageName = 'delivery-details';
export const productTemplatePageName = 'product-template';
export const salesOverviewPageName = 'sales-overview';
export const invoicePageName = 'invoice';

